import {useCallback, useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Range} from '~/common/FabricInvitation/components/Range/Range';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {selectEditorDisabled} from '~/common/fabric/reducers/fabricDesign/selectors';

export const LineHeight = () => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [lineHeight, setLineHeight] = useState();
  const editorDisabled = useSelector(selectEditorDisabled);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    const updateLineHeight = () => setLineHeight(canvas?.getActiveObjects()?.[0]?.lineHeight);

    updateLineHeight();
    canvas?.on('object:reset', updateLineHeight);

    return () => {
      canvas?.off('object:reset', updateLineHeight);
    };
  }, [canvas, activeObjects]);

  const onChangeHandler = useCallback(
    (value) => {
      activeObjects.forEach((obj) => {
        setLineHeight(value);
        obj.set('lineHeight', value);
      });

      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [activeObjects, canvas?.fire, canvas?.requestRenderAll]
  );

  return (
    <Range
      min={1}
      max={4}
      step="0.1"
      value={lineHeight}
      onChange={onChangeHandler}
      disabled={editorDisabled}
      dataQaId="step1-textheight-range"
    />
  );
};
